import { Loader } from "@/components/loader/Loader.tsx";
import { useMutation } from "@tanstack/react-query";
import { api } from "@/lib/http.ts";
import { useEffect, useRef } from "react";
import { useLocation, useSearch } from "wouter";

type StartThreadResp = { threadId: number } | { error: string };

export const StartThread = () => {
  const [, setLocation] = useLocation();
  const searchString = useSearch();
  const token = new URLSearchParams(searchString).get("token");
  const hasStarted = useRef(false);

  const mutation = useMutation({
    mutationFn: async (tokenValue: string) => {
      const resp = await api.post<StartThreadResp>("/api/a/threads/start", { token: tokenValue });
      return resp.data;
    },
    onSuccess: (data) => {
      if ("threadId" in data) {
        setLocation(`/threads/${data.threadId}`, { replace: true });
      } else {
        // Error response from server
        console.error("Start thread failed:", data.error);
        setLocation("/", { replace: true });
      }
    },
    onError: (error) => {
      console.error("Start thread request failed:", error);
      setLocation("/", { replace: true });
    },
  });

  useEffect(() => {
    if (token && !hasStarted.current) {
      hasStarted.current = true;
      mutation.mutate(token);
    } else if (!token) {
      setLocation("/", { replace: true });
    }
  }, [token, setLocation, mutation.mutate]);

  return <Loader />;
};
